export default "/img/CV.9d77b44786a48fb0565be75bf6c99221.png";